module.exports = "<div class=\"row cabecera\">\n    <div class=\"col-xs-2 logos\"><img src=\"assets/img/new-turnero.png\"></div>\n    <div class=\"col-xs-8 centro\">{{ $ctrl.centroAtencionSeleccionado.text }}</div>\n    <div class=\"col-xs-2 reloj\">{{ $ctrl.clock | date:'HH:mm:ss'}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/shared/header/headerLlamador.html
// module id = 474
// module chunks = 0